import { useEffect } from 'react';
import TimeFunction from '@/functions/TimeFunction';
import { TranslationFunction } from '@/commonTypes';
import styles from './styles.module.css';
interface DateComponentProps {
  createdAt?: string | Date; // allow both
  t: TranslationFunction;
  className?: string;
}
const DateComponent = ({ createdAt, t, className }: DateComponentProps) => {
  useEffect(() => {}, [createdAt]);
  return (
    <p className={`${styles.container} ${className}`}>
      {TimeFunction(createdAt, t) < '0' ? t(`secondsago`) : TimeFunction(createdAt, t)}
    </p>
  );
};

export default DateComponent;
